import React, { useEffect, useState } from 'react'
import { NOTEBOOKURL } from '../Config'
import PageTitleBanner from './Common/PageTitleBanner'


const Certificate = () => {
    const [data, setData] = useState([])
    const [mainData, setMainData] = useState([])
    const [pageIndex, setpageIndex] = useState(0)
    const [expandedItems, setExpandedItems] = useState({}); 

    const handleToggle = (index) => {
        setExpandedItems((prevState) => ({
            ...prevState,
            [index]: !prevState[index], 
        }));
    };
    const certificate = process.env.REACT_APP_Certificate_URL

    useEffect(() => {
        GetCertificateData()
    }, [])

    const GetCertificateData = async () => {
        try {
            const res = await fetch(`${NOTEBOOKURL}Photo/GetPhoto`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    TitleID: '',
                    Title: '',
                    TypeID: '',
                    Type: 'Certificate',
                    PaginationID: '-1',
                    PageLength: '',
                }),
            });

            const result = await res.json()
            console.log(result, "result")
            const tempt = result.data.slice(0, 6)
            setData(tempt)
            setMainData(result.data)

        } catch (error) {
            console.error('Error fetching Certificate data:', error);
        }
    };
    const handleNextData = (id) => {

        if ((id) * 6 >= mainData.length) {
            return
        }
        let tempt = [...mainData]
        let slicedArray = tempt.slice(id * 6, id * 6 + 6)

        setData(slicedArray)
        setpageIndex(prev => prev + 1)

    }
    const handlepreviousData = (id) => {
        if (id == -1) {
            return
        }

        let tempt = [...mainData]
        let slicedArray = tempt.slice(id * 6, id * 6 + 6)
        setData(slicedArray)
        setpageIndex(prev => prev - 1)

    }
  
    return (
        <>
            <PageTitleBanner title={"Certificate"} />
            <div id="content" className="site-content">
                <div className="faq-top secpadd">
                    <div className="container">
                        <div className="fp-testimonials-grid">

                            <div className="testi-list row" >
                                {data?.map((item, index) => {
                                    const isExpanded = expandedItems[index] || false;
                                    return (
                                        <div key={index} className="testi-item col-md-4">
                                            <div className="image-container" style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <img
                                                    src={`${certificate}${item.CertificateImage}`}
                                                    alt={`Certificate ${index + 1}`}
                                                    className="Image"
                                                    style={{
                                                        width: 600,
                                                        height: 500,
                                                        border: '1px solid gray',
                                                        marginLeft: '1px',
                                                        marginBottom: '10px'                                                       
                                                    }}
                                                />
                                            </div>

                                            <div className="title-container"
                                                style={{textalign: 'justify', overflow: 'auto', height: '100px',  display: 'inline-block', margintop: '10px', marginbottom: '15px', width: '100%' }} >
                                                <h4 style={{ textAlign: "justify",  marginTop: "5px",  marginBottom: "15px", marginLeft: "1%", whiteSpace: "normal", textOverflow: "ellipsis", lineHeight: "1.3", overflow: "hidden", height: isExpanded ? "auto" : "2.5em" }}  title={item.Title} >
                                                    {item.Title}
                                                </h4>

                                                <button onClick={() => handleToggle(index)}
                                                    style={{
                                                        marginLeft: '78%',
                                                        background: "none",
                                                        border: "none",
                                                        color: "#002A52",
                                                        textDecoration: "underline",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                        padding: "0",
                                                        // alignSelf: "flex-end",                                                         
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    {isExpanded ? "Show Less" : "Show More"}
                                                </button>
                                            </div>

                                        </div>

                                    );
                                })}
                            </div>                         

                            {data?.length > 0 && (
                                <>
                                    <button onClick={() => handlepreviousData(pageIndex - 1)} className='fp-btn-2nd readmore' >PREVIOUS</button>
                                    <button onClick={() => handleNextData(pageIndex + 1)} style={{ float: "right" }} className='fp-btn-2nd readmore'>NEXT</button>
                                </>
                            )}

                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Certificate


